import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-155q-17 0-33-7t-28-21L106-559q-9-11-14-24-5-12-5-27 0-9 3-18l6-18 78-157q10-20 29-32 19-11 42-11h470q23 0 42 11 19 12 30 32l77 157 6 18q3 9 3 18 0 15-5 27-5 13-14 24L541-183q-12 14-28 21t-33 7ZM367-630h226l-73-144h-80l-73 144Zm83 371v-311H191l259 311Zm60 0 259-311H510v311Zm150-371h128l-72-144H588l72 144Zm-488 0h128l72-144H244l-72 144Z"/>',
  f: '<path d="M359-625h242L500-846h-40L359-625Zm96 485v-435H92l363 435Zm50 0 363-435H505v435Zm154-485h215l-87-178q-11-20-30-32-19-11-42-11H557l102 221Zm-573 0h215l102-221H245q-23 0-42 11-19 12-29 32L86-625Z"/>',
};

export default data;
